import React, { FC } from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import summaryLabelStyles from './SummaryLabelStyles';
import Tooltip from '../../../../../../gqlCommon/components/presentation/tooltip/Tooltip';

interface ISummaryLabelTooltipProps {
  toggleTooltip: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
  text?: string;
}

const SummaryLabelTooltip: FC<ISummaryLabelTooltipProps> = ({ toggleTooltip, isOpen, text }) => {
  const styles = summaryLabelStyles();

  if (!text) {
    return null;
  }

  return (
    <>
      <IconButton
        disableRipple={true}
        onClick={() => toggleTooltip(true)}
        className={styles.tooltipIconButton}
        data-test="summary:discount:tooltip:button"
      >
        <InfoOutlinedIcon color={'primary'} viewBox={'0 0 28 28'} className={styles.tooltipIcon} />
      </IconButton>
      <Tooltip
        id={'summaryDiscountLabelTooltip'}
        isOpen={isOpen}
        onClose={() => toggleTooltip(false)}
        text={<Typography dangerouslySetInnerHTML={{ __html: text }} />}
      />
    </>
  );
};

export default SummaryLabelTooltip;
